<template>
    <v-layout :class="['our-partners', showOnMobile ? '' : 'hide-on-mobile']">
        <h3>Наши партнеры</h3>
        <v-flex class="partners">
            <v-flex class="partners-list">
                <div class="partner" v-for="item in partners" :key="item.message">
                    <v-tooltip v-model="item.show" top :disabled="!item.hint" :color="'#fff'" :max-width="'400px'">
                        <template v-slot:activator="{ on }">
                            <a v-if="item.url" :href="item.url" target="_blank" v-on="on">
                                <img class="partner-logo" :src="item.img" :style="item.style" :alt="item.name">
                            </a>
                            <img v-else class="partner-logo" :style="item.style" :src="item.img" :alt="item.name" v-on="on"/>
                        </template>
                        <span v-if="item.hint" v-html="item.hint" style="color: #000"></span>
                    </v-tooltip>
                </div>
            </v-flex>
        </v-flex>
    </v-layout>
</template>
<script>
export default {
    name: 'Partners',
    props: ['showOnMobile'],
    data: () => ({
        partners: [
            {
                name: 'Альфа',
                img: '/img/partners/alfa.png',
                show: false,
            },
            {
                name: 'Ингосстрах',
                img: '/img/partners/ingostrah-wp.svg',
                style: '-webkit-filter: grayscale(100%) brightness(200%);',
                show: false,
            },
            {
                name: 'Согласие',
                img: '/img/partners/soglasia.png',
                show: false,
            },
            {
                name: 'Совкомбанк',
                img: '/img/partners/sovkombank.svg',
                style: '-webkit-filter: grayscale(100%) brightness(170%);',
                show: false,
            },
            {
                name: 'Пари',
                img: '/img/partners/pari-grey.png',
                show: false,
            },
            {
                name: 'Макс',
                img: '/img/partners/makc.png',
                url: 'https://makc.ru/o-kompanii/bazovye-standarty.php',
                show: false,
            },
            {
                name: 'Зетта',
                img: '/img/partners/zetta.png',
                show: false,
            },
            {
                name: 'Ренессанс',
                img: '/img/partners/reness.png',
                show: false,
            },
            {
                name: 'Двадцать первый век',
                img: '/img/partners/sk21vek.png',
                show: false,
            },
            {
                name: 'Росгосстрах',
                img: '/img/partners/rosgosstrah.svg',
                style: '-webkit-filter: grayscale(100%) brightness(300%);',
                show: false,
            },
            {
                name: 'ВСК',
                img: '/img/partners/vsk.png',
                show: false,
            },
            {
                name: 'Тинькофф',
                img: '/img/partners/tinkoff.svg',
                url: 'https://acdn.tinkoffinsurance.ru/static/documents/417d017c-904c-4477-a106-e8bf32008054.pdf',
                style: '-webkit-filter: grayscale(100%) brightness(250%);',
                show: false,
            },
            {
                name: 'Сбер',
                img: '/img/partners/sber.svg',
                url: 'https://sberbankins.ru/bazovyi-standart',
                hint: 'ООО "Гетполис" совершает действия по привлечению потенциальных страхователей в целях заключения договоров страхования с ООО СК «Сбербанк страхование» по следующим видам страхования:<br>' +
                    'ОСАГО<br>' +
                    '<br>' +
                    'Договор с ООО СК «Сбербанк страхование»: № 701/22 от 10.03.2022<br>' +
                    'Информация об ООО СК «Сбербанк страхование»: https://sberbankins.ru/bazovyi-standart',
                show: false,
            },
            {
                name: 'Согаз',
                img: '/img/partners/sogaz.png',
                show: false,
            },
            {
                name: 'Югория',
                img: '/img/partners/yugoriya.png',
                show: false,
            },
            {
                name: 'Астро-волга',
                img: '/img/partners/astro-volga.svg',
                style: 'filter: grayscale(100%) brightness(170%);',
                url: 'https://astrovolga.ru/poluchatelyam-finansovykh-uslug/',
                show: false,
            },
            {
                name: 'Абсолют',
                img: '/img/partners/absolut.png',
                show: false,
            },
            {
                name: 'Гелиос',
                img: '/img/partners/gelios.svg',
                style: 'filter: grayscale(100%) brightness(145%);',
                url: 'https://skgelios.ru/fin-consumers/files/info.pdf',
                hint: 'ООО «Гетполис» действует в качестве агента и совершает действия по привлечению потенциальных страхователей в целях заключения договоров страхования с ООО Страховая Компания «Гелиос».<br>' +
                    '<br>' +
                    'Агентский договор № 61/АД/2267/2024 от 12 марта 2024 г.<br>' +
                    'Информация об ООО СК «Гелиос»:<br>https://skgelios.ru/fin-consumers/files/info.pdf',
                show: false,
            },
            {
                name: 'Энергогарант',
                img: '/img/partners/energo_garant.svg',
                style: 'filter: grayscale(100%) brightness(145%);',
                show: false,
            },
            /*{
                name: 'Ресо',
                img: '/img/partners/reso.png',
                show: false,
            },
            {
                name: 'Mafin',
                img: '/img/partners/mafin.png',
                show: false,
            },*/
        ]
    }),
}
</script>
<style scoped>
    img.partner-logo {
        -webkit-filter: grayscale(100%);
    }
    .our-partners{
        display: block;
        width: calc(100% + 150px);
    }
    .partners-list{
        display: flex;
        flex-wrap: wrap;
    }
    .partners{
        margin-left: -75px;
        margin-right: -75px;
        width: 100%;
        display: block;
    }
    .partners-list .partner{
        display: flex;
        align-items: center;
        justify-content: flex-start;
        width: 20%;
        padding: 50px 75px;
    }
    .partners-list .partner a{
        width: 100%;
    }
    .partners-list .partner img{
        max-width: 100%;
    }
    @media screen and (max-width: 1920px){
        .our-partners{
            width: calc(100% + 7.8vw)
        }
        .partners{
            margin-left: -77px;
            margin-right: -77px;
        }
        .partners-list .partner{
            padding: 30px 77px;
        }
    }
    @media screen and (max-width: 1600px){
        .partners{
            margin-left: -5vw;
            margin-right: -5vw;
        }
        .partners-list .partner{
            padding: 2vw 5vw;
        }
    }
    @media screen and (max-width: 960px){
        .our-partners.hide-on-mobile{
            display: none;
        }
        .partners-list .partner{
            width: 33.3%;
        }
    }
</style>



// WEBPACK FOOTER //
// resources/js/components/elements/Partners.vue